import React from "react"
import styled from "styled-components"
import { Td, Tr } from "~components/styled/table"
import SkeletonWrapper from "~components/SkeletonWrapper"
import moment from "moment"
import { UserShape } from "~shapes/user"
import UserDetailActions from "~components/users/UserDetailActions"
import colors from "~constants/colors"

export interface UserRowProps {
  user: UserShape
  isLoading: boolean
  onClickUserEdit: (id: string) => void
  onClickUserDelete: (user: any) => void
  onViewUser: (email: string) => void
  statusLabel: "Active" | "Inactive"
}

const UserRow = ({
  user,
  isLoading,
  onClickUserEdit,
  onClickUserDelete,
  onViewUser,
  statusLabel,
}: UserRowProps) => (
  <Tr isClickable onClick={() => onViewUser(user.email)}>
    <Td>
      <SkeletonWrapper isLoading={isLoading} width={52}>
        <StatusChip $active={statusLabel === "Active"}>
          {statusLabel}
        </StatusChip>
      </SkeletonWrapper>
    </Td>

    <Td>
      <SkeletonWrapper isLoading={isLoading} width={120}>
        <UserName>{user.profile?.name || "N/A"}</UserName>
      </SkeletonWrapper>
    </Td>

    <Td>
      <SkeletonWrapper isLoading={isLoading} width={160}>
        <CellText>{user.email}</CellText>
      </SkeletonWrapper>
    </Td>

    <Td>
      <SkeletonWrapper isLoading={isLoading} width={70}>
        <CellText>
          {moment(user.createdAt, "YYYY-MM-DD HH:mm:ss").format("MMM D, YYYY")}
        </CellText>
      </SkeletonWrapper>
    </Td>

    <Td style={{ cursor: "auto" }} onClick={e => e.stopPropagation()}>
      <SkeletonWrapper isLoading={isLoading}>
        <UserDetailActions
          onEdit={() => onClickUserEdit(user.id)}
          onDelete={() => onClickUserDelete(user)}
          compact
        />
      </SkeletonWrapper>
    </Td>
  </Tr>
)

const StatusChip = styled.span<{ $active: boolean }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  color: ${colors.white};
  background: ${p => (p.$active ? colors.green : colors.gray6)};
  white-space: nowrap;
`

const UserName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.gray3};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CellText = styled.div`
  font-size: 12px;
  color: ${colors.gray6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default UserRow
